export default __webpack_public_path__ + "static/media/ProximaNova-Regular.7bc9ce40.otf";